import { updateQueue } from '../services/queue';
import useLocalStorage from '../../../core/storage/use-local-storage';
import { StorageKey } from '../../../core/storage/storage-key';
import { useStableFunction } from '../../../core/hooks/use-stable-function';

const MAX_ARTICLES = 12;

export const useLastVisitedArticles = () => {
  const [lastVisitedArticles, setLastVisitedArticles] = useLocalStorage<string[]>(StorageKey.LastVisitedArticles, []);

  const updateLastVisitedArticles = useStableFunction((articleId: string) => {
    const updatedArticles = updateQueue(lastVisitedArticles, articleId, MAX_ARTICLES);
    setLastVisitedArticles(updatedArticles);
  });

  return {
    lastVisitedArticles,
    updateLastVisitedArticles,
  };
};
